(function () {
  'use strict';

  /* @ngdoc object
   * @name salesTarget
   * @description
   *
   */
  angular
    .module('salesTarget', [
      'ui.router'
    ]);
}());
